import { toast } from "@suraasa/placebo-ui"
import { FieldValues, UseFormSetError } from "react-hook-form"

import { APIError } from "@/api/utils"

export function narrowError(e: unknown): e is APIError {
  return e instanceof APIError
}

/**
 * [backendKey, frontendKey] OR [key] (if both key names are same)
 */
export const mapErrors = <T extends FieldValues>(
  err: any,
  options?: {
    setter?: UseFormSetError<T>
    fields: ([string, string] | [string])[]
  },
) => {
  if (!narrowError(err)) {
    toast.error("An unexpected error occurred!", {
      description: "Our team has been notified",
    })
    throw new Error(err)
  }

  const {
    errors: { fieldErrors, message },
  } = err

  if (message) {
    toast.error(message)
  }
  if (err.is500) {
    toast.error("Something went wrong.", {
      description: "Our team has been notified",
    })
  }

  if (fieldErrors && !options?.setter) {
    console.warn("> No setter provided to map field errors")
    const firstError = Object.entries(fieldErrors)[0]
    if (firstError) {
      const [k, v] = firstError
      toast.error(`Error on key '${k}'`, {
        description: typeof v === "string" ? v : JSON.stringify(v[0]),
      })
    }
  }

  if (!options) return
  const setter = options.setter

  if (!options?.fields || !setter) return

  options.fields.forEach((pair) => {
    if (!fieldErrors) return

    const key = pair[0]
    const message = Array.isArray(fieldErrors[key])
      ? (fieldErrors[key] as string[]).join("; ")
      : fieldErrors[key]
    if (pair.length === 1) {
      if (message) {
        setter(
          key as any,
          {
            message: message as string,
          },
          { shouldFocus: true },
        )
      }
    }
    if (pair.length === 2) {
      const frontendKey = pair[1]
      if (message) {
        setter(
          frontendKey as any,
          { message: message as string },
          { shouldFocus: true },
        )
      }
    }
  })
}
